import React from 'react';
// @ts-ignore: TS2459 — we know it's there at runtime
import { Footer } from '@PikaDoApp/pikado-web-dsm';

const CompanyFooter: React.FC = () => {
  return (
    <Footer
      FooterMainText="PikaDo LLC Suite 302, 4001 Kennett Pike, County of New Castle, Wilmington, Delaware 19807, USA"
      firstLinkText="www.PikaDo.io"
      secondLinkText="info@PikaDo.io"
    />
  );
};

export default CompanyFooter;
